import { render, staticRenderFns } from "./left-nav-section.vue?vue&type=template&id=b043110c&scoped=true"
import script from "./left-nav-section.vue?vue&type=script&lang=js"
export * from "./left-nav-section.vue?vue&type=script&lang=js"
import style0 from "./left-nav-section.vue?vue&type=style&index=0&id=b043110c&prod&lang=scss"
import style1 from "./left-nav-section.vue?vue&type=style&index=1&id=b043110c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b043110c",
  null
  
)

export default component.exports